var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"txtd",domProps:{"innerHTML":_vm._s(_vm.texts)}})
}
var staticRenderFns = []

export { render, staticRenderFns }